module.exports = __webpack_public_path__ + "img/logoComposite1.7e8b62f7.png";